<template>
  <b-modal
    v-model="isOpen"
    scrollable
    centered
    :title="title"
    size="lg"
    no-close-on-backdrop
    hide-footer
    @hidden="onClose"
    @ok="onClose"
  >
    <div class="d-flex justify-conetnt-between align-items-center">
      <b-input
        v-model="$v.policyFromId.$model"
        :state="checkErrors ? !$v.policyFromId.$error : null"
      />
      <b-icon
        icon="arrow-right"
        class="mx-3"
      />
      <b-input
        v-model="$v.policyToId.$model"
        :state="checkErrors ? !$v.policyToId.$error : null"
      />
    </div>

    <div class="d-flex justify-content-center mt-4">
      <b-button
        variant="primary"
        :disabled="isLoading"
        @click="transferPolicyData"
      >
        Объединить
        <b-spinner
          v-if="isLoading"
          variant="light"
          small
        />
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { api } from '@/helpers/api';
import { showMessage } from '@/helpers/utils';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'CombinePoliciesModal',
  mixins: [validationMixin],

  props: {
    modalName: {
      type: [String, Number],
      default: null,
    },
    title: {
      type: String,
      default: 'Объединение полисов',
    },
  },
  data: () => ({
    isOpen: true,
    isLoading: false,
    policyFromId: null,
    policyToId: null,
    checkErrors: false,
  }),
  validations: {
    policyToId: {
      required,
    },
    policyFromId: {
      required,
    },
  },
  methods: {
    onClose() {
      this.$store.commit(this.$types.CLOSE_MODAL, { modalName: this.modalName });
    },
    onClickSave() {
      this.onClose();
    },
    async transferPolicyData() {
      this.$v.$touch();
      this.checkErrors = true;

      if (this.$v.$error) {
        showMessage({
          type: 'warning',
          title: 'Ошибка валидации',
          message: 'Проверьте правильность заполнения полей',
        });
        console.log(this.$v);
        console.log(this.$v.$error);
        return;
      }
      this.isLoading = true;

      try {
        const response = await api.put('/v2/policy/transfer-attachments', {}, {
          params: {
            policyFromId: this.policyFromId,
            policyToId: this.policyToId,
          },
        });

        if (response.status === 200) {
          showMessage({
            type: 'success',
            title: 'Успешно',
            message: `Полисы успешно объединены. ID полисов: ${this.policyToId} - ${this.policyFromId}`,
          });
          this.policyToId = null;
          this.policyFromId = null;
          this.checkErrors = false;
        }
      } catch (e) {
        console.error(e);
        showMessage({
          type: 'error',
          title: 'Ошибка',
          message: 'Не удалось объединить полисы',
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
